'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    GoodsSlider: {
        displayName: 'GoodsSlider'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/GoodsSlider/GoodsSlider.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
} /**
   * Created by maximus on 30.12.16.
   */

var GoodsSlider = _wrapComponent('GoodsSlider')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(GoodsSlider, _Component);

    function GoodsSlider() {
        (0, _classCallCheck3.default)(this, GoodsSlider);
        return (0, _possibleConstructorReturn3.default)(this, (GoodsSlider.__proto__ || (0, _getPrototypeOf2.default)(GoodsSlider)).apply(this, arguments));
    }

    (0, _createClass3.default)(GoodsSlider, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('GoodsSlider', null, { folderName: 'GoodsSlider' });
            return _react3.default.createElement(View, {
                items: this.props.items,
                count: this.props.count,
                contentType: this.props.contentType,
                updateProducts: this.props.updateProducts,
                orderInOneClick: this.props.orderInOneClick,
                buyInCreditActive: this.props.buyInCreditActive
            });
        }
    }]);
    return GoodsSlider;
}(_react2.Component), _class.propTypes = {
    items: _react2.PropTypes.array,
    count: _react2.PropTypes.number,
    contentType: _react2.PropTypes.string,
    updateProducts: _react2.PropTypes.func,
    orderInOneClick: _react2.PropTypes.bool
}, _temp));

exports.default = GoodsSlider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsSlider/GoodsSlider.jsx
// module id = 1662
// module chunks = 0